import React from "react";
import { PLATFORM_COLOR_CLASS } from "./constants";
import { formatRand } from "./helpers";

const PlatformRow = ({ letter, color, label, earnings, pct }) => {
  const classes = PLATFORM_COLOR_CLASS[color] || PLATFORM_COLOR_CLASS.purple;
  return (
    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
      <div className="flex items-center gap-4">
        <div className={`w-10 h-10 rounded-lg ${classes.tile} flex items-center justify-center font-bold italic text-[14px]`}>
          {letter}
        </div>
        <p className="text-[14px] font-bold">{label}</p>
      </div>
      <div className="text-right">
        <p className="text-[16px] font-bold">{formatRand(earnings)}</p>
        <p className={`text-[11px] font-bold px-2 py-0.5 rounded-full inline-block mt-1 ${classes.pill}`}>
          {pct.toFixed(0)}% Share
        </p>
      </div>
    </div>
  );
};

export default PlatformRow;
